import React from 'react';
import './Contact.css';

const CONTACTS = [
  {
    label: 'General queries',
    email: 'admin@CWARA.org.uk',
    description: 'Membership, mailing list and general enquiries.',
  },
  {
    label: 'Events team',
    email: 'events@CWARA.org.uk',
    description: 'Quiz nights, Advent Windows, street parties and volunteering.',
  },
  {
    label: 'CWARA Chair',
    email: 'chair@CWARA.org.uk',
    description: 'Jill Bartlett — for matters requiring the Chair\'s attention.',
  },
];

const Contact = () => (
  <div className="container">
    <section className="page-intro">
      <span className="kicker">Say hello</span>
      <h1>Contact us</h1>
      <p className="lead" style={{ maxWidth: 600 }}>
        Got a question, an idea, or something for the noticeboard? The easiest way to
        reach us is by email — click an address below to open your mail client.
      </p>
    </section>

    <section className="section-tight">
      <div className="contact-list">
        {CONTACTS.map(({ label, email, description }) => (
          <div className="card contact-card" key={email}>
            <span className="kicker">{label}</span>
            <div className="contact-info">
              <p style={{ marginTop: 10 }}>{description}</p>
            </div>
            <a href={`mailto:${email}`} className="contact-email">{email}</a>
          </div>
        ))}
      </div>

      <div className="card contact-in-person">
        <span className="kicker">In person</span>
        <p style={{ marginTop: 10, fontWeight: 700 }}>Community Hall, Waverley Road</p>
        <p className="muted" style={{ fontSize: '0.92rem' }}>
          Open committee meetings — first Tuesday of the month, 7pm. All welcome.
        </p>
      </div>
    </section>
  </div>
);

export default Contact;
